import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recollectionsettingspasswordmodal',
  templateUrl: './recollectionsettingspasswordmodal.component.html',
  styleUrls: ['./recollectionsettingspasswordmodal.component.css']
})
export class RecollectionsettingspasswordmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
